import React from "react";
import { useRef } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Chart from "react-apexcharts";
import Warehousecharts from "./Warehousecharts";
import Putawaytimechart from "./Putawaytimechart";
import Warehousequality from "./Warehousequality";
import Warehousetransaction from "./Warehousetransaction";
import { Link } from "react-router-dom";

export default function GoodsOverview() {
  const RecievingRef = useRef(null);
  const QualityRef = useRef(null);
  const PutawayRef = useRef(null);
  const RejectedOrderRef = useRef(null);
  const handleScroll = (ref) => {
    console.log("scrool down");
    window.scrollTo({
      top: ref.offsetTop - 100,
      left: 0,
      behavior: "smooth",
    });
  };
  const state = {
    stroke: {
      lineCap: "round",
    },
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        fontSize: "14px",
        fontWeight: "700",
        fontFamily: "Poppins",
        position: "right",
        horizontalAlign: "center",

        // labels: {
        //   show: true,
        //   name: "Total Issus",
        //   value: 263,
        // },
      },

      title: {
        text: "125",
        align: "center",
        margin: 10,
        offsetX: -68,
        offsetY: 105,
        floating: false,
        style: {
          fontSize: "24px",
          fontWeight: "bold",
          color: "#000",
        },
      },
      subtitle: {
        text: "Items",
        align: "center",
        margin: 10,
        offsetX: -68,
        offsetY: 135,
        floating: false,
        style: {
          fontSize: "16px",
          fontWeight: "300",
          color: "#000",
        },
      },
      // subtitle: {
      //   text: ,
      //   align: "center",
      //   margin: 10,
      //   offsetX: 0,
      //   offsetY: 105,
      //   floating: false,
      //   style: {
      //     fontSize: "14px",
      //     fontWeight: "bold",
      //     color: "#000",
      //   },
      // },
      labels: ["Major Issues", "Minor Issues", "Ongoing Issues"],
      colors: ["#FF0000", "#FFFF00", "#00FF00"],

      plotOptions: {
        pie: {
          customScale: 1,
          donut: {
            size: "83%",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
        },
      },
    },

    series: [45, 35, 20],
  };
  return (
    <div>
      <div class="flex flex-wrap justify-center mt-8 ">
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 "
          onClick={() => {
            handleScroll(RecievingRef.current);
          }}
        >
          <div className="text-center  mt-4 pt-8">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="path-1-outside-1_331_1023"
                    maskUnits="userSpaceOnUse"
                    x="0.999985"
                    y="1"
                    width="22"
                    height="22"
                    fill="black"
                  >
                    <rect
                      fill="white"
                      x="0.999985"
                      y="1"
                      width="22"
                      height="22"
                    />
                    <path d="M12 2C14.3136 2 16.5555 2.80219 18.3439 4.2699C20.1323 5.7376 21.3565 7.78 21.8079 10.0491C22.2592 12.3182 21.9098 14.6736 20.8192 16.714C19.7286 18.7543 17.9643 20.3534 15.8268 21.2388C13.6894 22.1242 11.3111 22.241 9.09715 21.5694C6.88322 20.8978 4.97064 19.4793 3.6853 17.5557C2.39996 15.6321 1.82138 13.3222 2.04815 11.0198C2.27492 8.71741 3.29301 6.56486 4.92894 4.92893L7.75736 7.75736C6.7758 8.73891 6.16495 10.0304 6.02889 11.4119C5.89283 12.7933 6.23998 14.1792 7.01118 15.3334C7.78239 16.4876 8.92993 17.3387 10.2583 17.7416C11.5866 18.1446 13.0136 18.0745 14.2961 17.5433C15.5786 17.0121 16.6372 16.0526 17.2915 14.8284C17.9459 13.6042 18.1555 12.1909 17.8847 10.8295C17.6139 9.468 16.8794 8.24256 15.8064 7.36194C14.7333 6.48132 13.3881 6 12 6L12 2Z" />
                  </mask>
                  <path
                    d="M12 2C14.3136 2 16.5555 2.80219 18.3439 4.2699C20.1323 5.7376 21.3565 7.78 21.8079 10.0491C22.2592 12.3182 21.9098 14.6736 20.8192 16.714C19.7286 18.7543 17.9643 20.3534 15.8268 21.2388C13.6894 22.1242 11.3111 22.241 9.09715 21.5694C6.88322 20.8978 4.97064 19.4793 3.6853 17.5557C2.39996 15.6321 1.82138 13.3222 2.04815 11.0198C2.27492 8.71741 3.29301 6.56486 4.92894 4.92893L7.75736 7.75736C6.7758 8.73891 6.16495 10.0304 6.02889 11.4119C5.89283 12.7933 6.23998 14.1792 7.01118 15.3334C7.78239 16.4876 8.92993 17.3387 10.2583 17.7416C11.5866 18.1446 13.0136 18.0745 14.2961 17.5433C15.5786 17.0121 16.6372 16.0526 17.2915 14.8284C17.9459 13.6042 18.1555 12.1909 17.8847 10.8295C17.6139 9.468 16.8794 8.24256 15.8064 7.36194C14.7333 6.48132 13.3881 6 12 6L12 2Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M12 2V1H11V2L12 2ZM18.3439 4.2699L18.9783 3.49689L18.3439 4.2699ZM20.8192 16.714L21.7011 17.1854L20.8192 16.714ZM15.8268 21.2388L16.2095 22.1627L15.8268 21.2388ZM9.09715 21.5694L8.80687 22.5263L9.09715 21.5694ZM3.6853 17.5557L2.85383 18.1113L3.6853 17.5557ZM2.04815 11.0198L1.05297 10.9218L2.04815 11.0198ZM4.92894 4.92893L5.63604 4.22182L4.92894 3.51472L4.22183 4.22182L4.92894 4.92893ZM7.75736 7.75736L8.46447 8.46446L9.17157 7.75736L8.46447 7.05025L7.75736 7.75736ZM6.02889 11.4119L5.03371 11.3139L6.02889 11.4119ZM7.01118 15.3334L6.17971 15.889L7.01118 15.3334ZM10.2583 17.7416L9.96801 18.6986L10.2583 17.7416ZM14.2961 17.5433L13.9134 16.6194L14.2961 17.5433ZM17.2915 14.8284L16.4096 14.357L17.2915 14.8284ZM17.8847 10.8295L16.9039 11.0245L17.8847 10.8295ZM15.8064 7.36194L16.4408 6.58893L15.8064 7.36194ZM12 6H11V7H12V6ZM12 3C14.0822 3 16.1 3.72197 17.7095 5.04291L18.9783 3.49689C17.0111 1.88241 14.5449 1 12 1V3ZM17.7095 5.04291C19.3191 6.36384 20.4209 8.202 20.8271 10.2442L22.7886 9.85401C22.2922 7.358 20.9456 5.11136 18.9783 3.49689L17.7095 5.04291ZM20.8271 10.2442C21.2333 12.2864 20.9188 14.4062 19.9373 16.2426L21.7011 17.1854C22.9008 14.941 23.2851 12.35 22.7886 9.85401L20.8271 10.2442ZM19.9373 16.2426C18.9557 18.0789 17.3678 19.5181 15.4441 20.3149L16.2095 22.1627C18.5607 21.1888 20.5015 19.4298 21.7011 17.1854L19.9373 16.2426ZM15.4441 20.3149C13.5204 21.1117 11.38 21.2169 9.38744 20.6125L8.80687 22.5263C11.2422 23.2651 13.8583 23.1366 16.2095 22.1627L15.4441 20.3149ZM9.38744 20.6125C7.3949 20.008 5.67358 18.7314 4.51677 17.0001L2.85383 18.1113C4.26771 20.2273 6.37154 21.7876 8.80687 22.5263L9.38744 20.6125ZM4.51677 17.0001C3.35997 15.2688 2.83925 13.19 3.04334 11.1178L1.05297 10.9218C0.803523 13.4545 1.43996 15.9953 2.85383 18.1113L4.51677 17.0001ZM3.04334 11.1178C3.24743 9.04567 4.1637 7.10837 5.63604 5.63604L4.22183 4.22182C2.42231 6.02134 1.30241 8.38915 1.05297 10.9218L3.04334 11.1178ZM4.22183 5.63604L7.05025 8.46446L8.46447 7.05025L5.63604 4.22182L4.22183 5.63604ZM7.05025 7.05025C5.9051 8.1954 5.19245 9.70219 5.03371 11.3139L7.02408 11.5099C7.13746 10.3587 7.6465 9.28243 8.46447 8.46446L7.05025 7.05025ZM5.03371 11.3139C4.87497 12.9256 5.27997 14.5424 6.17971 15.889L7.84265 14.7779C7.19998 13.816 6.91069 12.6611 7.02408 11.5099L5.03371 11.3139ZM6.17971 15.889C7.07945 17.2355 8.41825 18.2285 9.96801 18.6986L10.5486 16.7847C9.44161 16.4489 8.48532 15.7397 7.84265 14.7779L6.17971 15.889ZM9.96801 18.6986C11.5178 19.1687 13.1826 19.0869 14.6788 18.4672L13.9134 16.6194C12.8447 17.0621 11.6555 17.1205 10.5486 16.7847L9.96801 18.6986ZM14.6788 18.4672C16.175 17.8474 17.41 16.728 18.1734 15.2998L16.4096 14.357C15.8643 15.3772 14.9821 16.1767 13.9134 16.6194L14.6788 18.4672ZM18.1734 15.2998C18.9369 13.8715 19.1814 12.2227 18.8655 10.6344L16.9039 11.0245C17.1296 12.1591 16.9549 13.3368 16.4096 14.357L18.1734 15.2998ZM18.8655 10.6344C18.5496 9.046 17.6926 7.61632 16.4408 6.58893L15.172 8.13495C16.0662 8.8688 16.6783 9.89 16.9039 11.0245L18.8655 10.6344ZM16.4408 6.58893C15.1889 5.56154 13.6195 5 12 5L12 7C13.1568 7 14.2778 7.4011 15.172 8.13495L16.4408 6.58893ZM13 6L13 2L11 2L11 6H13Z"
                    fill="#1F78B4"
                    mask="url(#path-1-outside-1_331_1023)"
                  />
                  <path
                    d="M12 12L5 5"
                    stroke="#1F78B4"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">07:01</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Receiving Cycle Time
          </h1>
          <p className="text-lime-400 text-center mb-1 pt-4">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">45.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4 pt-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          className="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6"
          onClick={() => {
            handleScroll(QualityRef.current);
          }}
        >
          <div className=" px-9 mt-7 ">
            <CircularProgressbar
              value={64}
              text={`${64}%`}
              circleRatio={0.75}
              styles={buildStyles({
                rotation: 1 / 2 + 1 / 8,
                strokeLinecap: "butt",
                // trailColor: "#26F32E",
                textColor: "black",
                pathColor: "#26F32E",
                // trailColor: "gold"
              })}
            />
          </div>
          <h1 className="text-lg text-center text-gray-500 font-bold ">
            Quality Rate of Goods In
          </h1>
          <p className="text-red-600 text-center pt-2 ">
            <span>
              <span className="inline-block">
                {" "}
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
              <span className="ml-1 font-medium">45.38%</span>
            </span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                M
              </button>
            </div>
          </div>
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 "
          onClick={() => {
            handleScroll(PutawayRef.current);
          }}
        >
          <div className="text-center  mt-4 pt-8">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1 left-1.5"
                  width="46"
                  height="46"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.28249 5.28248C3.72835 6.83662 2.76118 8.88154 2.54575 11.0688C2.33032 13.2561 2.87996 15.4504 4.10104 17.2779C5.32211 19.1054 7.13906 20.4529 9.24229 21.0909C11.3455 21.7289 13.6049 21.6179 15.6355 20.7769C17.6661 19.9358 19.3422 18.4166 20.3783 16.4783C21.4143 14.5399 21.7462 12.3023 21.3175 10.1466C20.8887 7.991 19.7257 6.05072 18.0267 4.6564C16.3278 3.26208 14.1979 2.5 12 2.5"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M12 12L7 7"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path d="M12 2.5V5" stroke="#1F78B4" stroke-linecap="round" />
                  <path
                    d="M21 12L19 12"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path d="M12 19V21" stroke="#1F78B4" stroke-linecap="round" />
                  <path
                    d="M5 12L3 12"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">07:01</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Putaway Cycle Time
          </h1>
          <p className="text-red-600 text-center mb-1 pt-4">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4 pt-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div
          class="w-full flex-1 shadow-md shadow-slate-400  bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl "
          onClick={() => {
            handleScroll(RejectedOrderRef.current);
          }}
        >
          <div className="text-center  mt-4 pt-8">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-[5px] left-[5px] top-1 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.8684 17.263L17.222 16.9095L17.5755 17.263L17.222 17.6166L16.8684 17.263ZM13.0246 12.7121L17.222 16.9095L16.5149 17.6166L12.3175 13.4192L13.0246 12.7121ZM17.222 17.6166L13.0246 21.814L12.3175 21.1069L16.5149 16.9095L17.222 17.6166Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M13.7204 8.86841L17.9177 8.86841"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.8684 17.2631H8.47368C6.15553 17.2631 4.27631 15.3839 4.27631 13.0658V13.0658C4.27631 10.7476 6.15553 8.86841 8.47368 8.86841H9.52302"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">34</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Rejected Orders
          </h1>
          <p className="text-lime-400 text-center mb-1 pt-4">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">05.25%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4 pt-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-8" ref={RejectedOrderRef}>
        <div class=" shadow-slate-400 shadow-md bg-white rounded-lg flex-1">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-xl font-bold ml-6"> Rejected Orders</h3>
          </div>
          <div className="flex flex-wrap pb-2">
            <div className="flex-1 flex-wrap ">
              <Chart
                // className="sm:w-32"
                //@ts-ignore
                options={state.options}
                series={state.series}
                type="donut"
                width="380"
              />
            </div>
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 mt-1">
              <div className="flex p-2 -mt-2">
                <div className=" text-center w-fit align-middle  cursor-pointer pb-2">
                  <div className="flex">
                    <p className="ml-5 font-bold  text-red-700"> A Grade</p>
                  </div>
                  <p className=" text-lg text-black ml-4">496,362 items</p>
                </div>
                <div className=" text-center w-fit align-middle ml-1  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-yellow"> B Grade</p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-5">
                    942,654 items
                  </p>
                </div>
                <div className=" text-center w-fit align-middle ml-1  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-green-500">
                      {" "}
                      C Grade
                    </p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-5">
                    654,485 items
                  </p>
                </div>
              </div>
              <div class="relative pt-1 px-12 mt-1">
                <div className="flex text-lg ">
                  <p className="font-bold text-2xl ml-2 mr-3">594 </p> Total
                </div>
                <div class="overflow-hidden h-6 mb-4 text-xs flex rounded-2xl bg-cyan-200">
                  <div
                    style={{ width: "20%" }}
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                  ></div>
                  <div
                    style={{ width: "15%" }}
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow"
                  ></div>
                  <div
                    style={{ width: "15%" }}
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref={RecievingRef}>
        {" "}
        <Warehousecharts />
      </div>
      <div ref={PutawayRef}>
        {" "}
        <Putawaytimechart />
      </div>
      <div ref={QualityRef}>
        {" "}
        <Warehousequality />
      </div>
      <div>
        {" "}
        <Warehousetransaction />
      </div>
    </div>
  );
}
